import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getHomeMetaSliceContent = createAsyncThunk('/homeMetas/content', async () => {
	const response = await axios.post(`${API_URL}/getHomeMetaData`);
    console.log(response.data);
	return response;
})

export const homeMetaSlice = createSlice({
    name: 'homeMetas',
    initialState: {
        isLoading: false,
        homeMetas : []
    },
    reducers: {
    },
    extraReducers: {
		[getHomeMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getHomeMetaSliceContent.fulfilled]: (state, action) => {
			state.homeMetas = action.payload.data
			state.isLoading = false
		},
		[getHomeMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default homeMetaSlice.reducer